

const PORTALS = [
  {
    name: 'Main Portal',
    url: 'https://portal.sisyaclass.com',
    area: 'All primary controls are here',
  },
  {
    name: 'AI Portal',
    url: 'https://aiportal.sisyaclass.com',
    area: 'AI & Doubt related details',
  },
  {
    name: 'Analytics Portal',
    url: 'https://analytics.sisyaclass.com',
    area: 'All analytics related to student, course & teachers',
  },
];

export function PortalLinksPage() {
  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Portal Links</h1>
          <p className="sub">Access other systems in the Sisya platform</p>
        </div>
      </div>

      <div className="table-wrap">
        <table className="data">
          <thead>
            <tr>
              <th style={{ width: '25%' }}>Portal Name</th>
              <th style={{ width: '15%' }}>Link</th>
              <th>Area</th>
            </tr>
          </thead>
          <tbody>
            {PORTALS.map((portal) => (
              <tr key={portal.name}>
                <td>
                  <strong>{portal.name}</strong>
                </td>
                <td>
                  <a
                    href={portal.url}
                    target="_blank"
                    rel="noreferrer"
                    className="btn btn-ghost btn-sm"
                    style={{ padding: '0 8px', color: 'var(--accent)' }}
                  >
                    Open Link
                  </a>
                </td>
                <td style={{ color: 'var(--muted)' }}>{portal.area}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
